import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ShipmentStatusBadge } from '@/components/ShipmentStatusBadge'
import { formatDate } from '@/lib/format'
import { getShipmentAction, SHIPMENT_ACTION_LABELS } from '@/lib/shipment'
import type { ShipmentAction } from '@/lib/shipment'
import type { Shipment } from '@/api/types'

const NO_LABEL_TEXT = 'Ingen fraktsedel ännu'

interface CustomerDeliveryRowProps {
  shipment: Shipment
  canManage: boolean
  isDisabled: boolean
  onAction: (shipment: Shipment, action: ShipmentAction) => void
}

export function CustomerDeliveryRow({ shipment, canManage, isDisabled, onAction }: CustomerDeliveryRowProps): React.ReactElement {
  const action = getShipmentAction(shipment)
  const visibleAction = canManage ? action : null

  const handleActionClick = (): void => {
    if (visibleAction !== null) {
      onAction(shipment, visibleAction)
    }
  }

  return (
    <li className="flex items-center">
      <Link
        to={`/shipments/${shipment.id}`}
        className="group flex min-w-0 flex-1 items-center gap-3 px-3 py-3 transition-colors hover:bg-muted/40"
      >
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <p className="font-medium group-hover:underline">Leverans #{shipment.sequence}</p>
            <ShipmentStatusBadge status={shipment.status} />
          </div>
          <p className="truncate text-sm text-muted-foreground">
            {formatDate(shipment.created_at)} · {shipment.postnord_shipment_id ?? NO_LABEL_TEXT}
          </p>
        </div>
        <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
      </Link>
      {visibleAction !== null && (
        <Button
          variant="ghost"
          size="sm"
          className="mx-2 shrink-0 rounded-none text-destructive hover:text-destructive"
          disabled={isDisabled}
          onClick={handleActionClick}
        >
          {SHIPMENT_ACTION_LABELS[visibleAction]}
        </Button>
      )}
    </li>
  )
}
